import axios from "axios";
var instance2 = axios.create({
  baseURL: "https://wx.mygolbs.com/MyBusWeChatMessage"
});
// axios.defaults.baseURL = `http://192.168.1.218:10006/MyBusWeChatMessage/`;

instance2.defaults.timeout = 10000;
instance2.defaults.retry = 0;
instance2.defaults.retryDelay = 1000;
instance2.interceptors.request.use(
  config => {
    console.log(config, "config");
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

instance2.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);
// console.log(instance2);
let http = {
  get: (url, param) => {
    console.log(url);
    return new Promise((resolve, reject) => {
      instance2({
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        },
        method: "GET",
        url: url,
        params: param
      })
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  post: (url, param) => {
    return new Promise((resolve, reject) => {
      instance2({
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        method: "POST",
        url: url,
        data: param
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
export default http;



// WEBPACK FOOTER //
// ./static/http.js